export default {
    OpenApi: {
        menu: '开放 API',
        appList: 'API 应用',
        createApp: '创建应用',
        cancel: '取消',
        source: '来源',
        sourcePage: '页面',
        sourceApi: 'API',
        requestNo: '客户请求编号',
        batchNo: '批次',
        actualAmount: '实际执行金额',
        walletAmount: '钱包扣减/入账',
        bindRecords: 'API 绑定/解绑记录',
        dataTime: '数据时间',
        action: '动作',
        bind: '绑定',
        unbind: '解绑',
        targetBc: '目标 BC',
        result: '结果',
        reason: '原因',
        verifiedAt: '回查确认时间',
        appSecret: '应用密钥（App Secret）',
        resetSecret: '重置密钥',
        resetConfirm: '重置后旧密钥立即失效，确定继续？',
        secretTitle: '请保存应用密钥',
        secretTip: '密钥仅显示这一次，关闭后无法再次查看，平台只保存其哈希值。请立即复制并妥善保管，丢失只能重置。',
        copy: '复制',
        copied: '已复制',
        savedIt: '我已保存',
        appName: '应用名称',
        appId: '应用 ID',
        keyId: '密钥 ID',
        publicKey: '公钥',
        publicKeyTip: '请在本地生成 RSA 密钥对（2048-4096 位，PS256），仅粘贴公钥（PEM 或 JWK）。私钥请勿上传，平台不保存私钥。',
        ipList: 'IP 白名单',
        ipListTip: '每行一个公网 IP 或 CIDR，IPv4 最小 /8，IPv6 最小 /32，主机位须为 0，最多 50 条。',
        status: '状态',
        statusPending: '待东坤开通',
        statusActive: '已启用',
        statusRevoked: '已撤销',
        scopes: '已开通权限',
        accounts: '授权账户数',
        readonlyTip: '权限与授权账户由东坤审核后开通，此处仅供查看。',
        createdAt: '创建时间',
        detail: '详情',
        addKey: '新增公钥（换钥）',
        revokeKey: '撤销此公钥',
        updateIp: '修改 IP 白名单',
        revokeApp: '撤销应用',
        revokeConfirm: '撤销后该应用将立即无法调用，确定继续？',
        smsTitle: '安全验证',
        smsTip: '该操作将影响资金接口的访问凭据，需先验证手机短信。',
        sendCode: '获取验证码',
        code: '验证码',
        verifyAndSubmit: '验证并提交',
        codeRequired: '请输入验证码',
        nameRequired: '请输入应用名称',
        keyRequired: '请粘贴公钥',
        ipRequired: '请至少填写一条 IP',
        success: '操作成功',
        empty: '暂无应用',
        enterpriseOnly: '仅企业主账号可管理 API 应用',
    },
    menu: { // 登录
        home: '首页',
        foundApply: '开户申请',
        foundTikTokBatch: 'TikTok 批量开户',
        account: '账户管理',
        subAccount: '成员管理',
        accountList: '账户列表',
        subAccountList: '成员列表',
        accountRecord: '开户记录',
        accountRecharge: '智能充值',
        accountMonitor: '账户监控',
        accountMonitorEr: '账户监控',
        check: '对账管理',
        checkWallet: '钱包充值记录',
        checkBalance: '钱包变动记录',
        checkCreditBalance: '授信变动记录',
        CheckConsume: '广告消耗明细',
        helpCenter: '帮助中心',
        marketingTool: '红人营销工具',
        crossBorderBrowser: '跨境浏览器',
        storeOperationTools: 'TK店铺运营工具',
        AdvertisementManagement: '广告管理',
        TikTok: 'TikTok',
        Partner: '合作伙伴',
        USCloudPhone: '美国云手机号',
        AccountOpeningManagement: '开户管理',
        cooperativePartner: '合作伙伴',
        subClient: '客户管理',
        subClientList: '客户列表',
        subClientAdvertiserList: '子客户广告列表',
        subClientCheckWallet: '交易记录',
        subClientAccountRecord: '子客户开户记录',
        promotion: '推广',
        agentSubAccount: '二代子账号列表',
        mediaAuth: '媒体管理',
        advertiserTransaction: '广告交易明细',
        advertiserTransfer: '广告转移明细',
        checkCreditLimit: '授信变动记录',
        monthSettlement: '月结账单',
    }, crumb: {
        home: '首页',
        foundApply: '开户申请',
        foundTikTokBatch: 'TikTok 批量开户',
        Account: '账户管理',
        AccountList: '账户列表',
        AccountRecord: '开户记录',
        AccountRecharge: '智能充值',
        AccountMonitor: '账户监控',
        Check: '对账管理',
        CheckWallet: '钱包充值记录',
        CheckBalance: '钱包明细',
        CheckCredit: '信用余额明细',
        CheckConsume: '广告消耗明细',
        CheckLimit: '授信变动明细',
    }, header: {
        Settings: '帐号设置',
        LogOut: '退出'
    }, home: { // 登录
        AssetOverview: '资产概览',
        wallet: '钱包余额',
        AdvertisingAccount: '广告账户余额',
        PlatformWallet: '平台钱包',
        creditBalance: '信用余额',
        RechargeWallet: '充值钱包',
        ViewDetails: '查看明细',
        ActiveAccountBalance: '活跃账户余额',
        FrozenBalance: '被冻结余额',
        PlatformGifts: '平台赠金',
        UsedCredit: '已使用授信',
        CreditLimit: '授信额度',
        AccountOpeningApplication: '开户申请',
        inReview: '审核中',
        ToBeModified: '待修改',
        GoAndModifyIt: '去修改',
        DisableRate: 'Tiktok消耗封户率',
        KwaiDisableRate: 'Kwai消耗封户率',
        AccountDisableRate: 'Tiktok账户封户率',
        KwaiAccountDisableRate: 'Kwai账户封户率',
        PassedInThePast30Days: '近30天已通过',
        ApplyForAccountOpening: '申请开户',
        PopularEntrance: '热门入口',
        AccountOpeningApplication2: '开户申请',
        IntelligentRecharge: '智能充值',
        AccountReconciliationManagement: '对账管理',
        account: '账户管理',
        WalletRecharge: '钱包充值',
        RechargeAmount: '充值金额',
        EnterAmount: '请输入充值金额',
        PaymentMethod: '支付方式',
        Cancel: '取消',
        ConfirmRecharge: '确认充值',
        Message1: "您充值到平台账户的美金余额，",
        Message2: "不包含已经充值到媒体平台的金额",
        Message3: "充值到媒体平台广告账户的总余额",
        Message4: "平台授予的信用额度余额，",
        Message5: "计算方式为：总授信额度-已使用额度",
        Message6: "新增功能上线啦! 快来帮助中心查看如何使用",
        Validity: '有效期',
    }, login: { // 登录
        title: '登录',
        NoAccount: '没有账号？',
        register: '去注册',
        WelcomeToLogin: '欢迎登录东坤Adseasy',
        PleaseEnterYourPhoneNumberOrEmailAddress: '请输入手机号或邮箱',
        PleaseEnterYourLoginPassword: '请输入登录密码',
        ForgotPassword: '忘记密码？',
        VerificationCodeLogin: '验证码登录',
        logOn: '登录',
        LoginSuccess: '成功登录,正在跳转。。。',
        Mail: '邮箱',
        Password: '密码',
        VerificationCode: '验证码',
        MasterAccountLogin: '切换主账户登录',
        SubAccountLogin: '切换子账户登录',
    }, register: { // 注册
        title: '注册',
        ExistingAccount: '已有账号？',
        GoLogIn: '去登陆',
        WelcomeToRegister: '欢迎注册',
        PleaseEnterYourPhoneNumber: '请输入手机号（作为登录的首选账号）',
        LoginPassword: '注意:密码需包含大小写字母及数字（字符数量不限）',
        InvitationCode: '邀请码',
        PlaInvitationCode: '注意:有邀请码请输入,无不需要输入',
        ObtainVerificationCode: '获取验证码',
        PleaseEnterYourFrequentlyUsedEmail: '请输入您常用邮箱（作为备选账号，此项非必填）',
        PleaseEnterA6_20DigitLoginPassword: '请输入6-20位登录密码（需包含大小写字母和数字）',
        FreeRegistration: '注册',
        IHaveReadAndAmWillingToAccept: '我已阅读并愿意接受',
        TermsOfService: '《服务条款》',
        and: '和',
        PrivacyStatement: '《隐私声明》',
        ElMPleaseEnterYourPhoneNumber: '请输入手机号码',
        ElMPleaseEnterYourEmailNumber: '请输入邮箱号码',
        ElMPleaseEnterTheVerificationCode: '请输入验证码',
        ElMPleaseEnterPassword: '请输入密码',
        PleaseAgreeToTheServiceAgreement: '请同意服务协议',
        SuccessfullySentSMSVerificationCode: '成功发送短信验证码',
        SuccessfullySentEmailVerificationCode: '成功发送邮件验证码',
        UserAgreement: '《用户协议》',
        UserAgreementAdvertisingComplianceManagementSystem: '《广告合规管理制度》',
        ServiceAndInformationCollectionAgreement: '《服务及信息收集协议》',
        AccountLogin: '账号登录',
        EmailLogin: '邮箱登录',
        VerificationCodeLogin: '验证码登录',
    }, forget: {// 找回密码
        title: '找回密码',
        NoAccount: '没有账号？',
        register: '去注册',
        RetrievePassword: '找回密码',
        PleaseEnterYourPhoneNumber: '请输入手机号码',
        PleaseEnterTheMobileVerificationCode: '请输入验证码',
        SuccessfullySentSMSVerificationCode: '成功发送短信验证码',
        ObtainVerificationCode: '获取验证码',
        ReturnToLogin: '返回登录',
        VerifyWithEmail: '用邮箱验证',
        PleaseEnterYourEmailNumber: '请输入邮箱号码',
        PleaseEnterTheEmailVerificationCode: '请输入邮箱验证码',
        SuccessfullySentEmailVerificationCode: '成功发送邮件验证码',
        VerifyWithMobilePhone: '用手机验证',
        Verify: '验证',
        NewPassword: '请输入新密码',
        AgainNewPassword: '请再次输入新密码',
        NewPasswordLogin: '修改成功，请重新登录',
    }, loginSMS: {// 验证码登录
        title: '验证码登录',
        NoAccount: '没有账号？',
        register: '去注册',
        WelcomeToLogin: '欢迎登录东坤Adseasy',
        PleaseEnterYourPhoneNumber: '请输入手机号',
        PleaseEnterTheMobileVerificationCode: '请输入手机验证码',
        SuccessfullySentSMSVerificationCode: '成功发送短信验证码',
        ObtainVerificationCode: '获取验证码',
        PleaseEnterYourEmailAddress: '请输入邮箱',
        PleaseEnterTheEmailVerificationCode: '请输入邮箱验证码',
        SuccessfullySentEmailVerificationCode: '成功发送邮件验证码',
        PasswordLogin: '密码登录',
        EmailVerificationCodeLogin: '邮箱验证码登录',
        MobileVerificationLogin: '手机验证登录',
        logOn: '登录'
    }, password: { // 修改密码
        title: '修改密码',
        ChangePassword: '修改密码',
        PleaseEnterANewPassword: '请输入6-20位新密码（需包含大小写字母和数字）',
        PleaseEnterANewPassword2: '请输入新密码',
        PleaseEnterTheNewPasswordAgain: '请再次输入新密码',
        ConfirmModifications: '确认修改',
        ReturnToLogin: '返回登录',
        ModificationSuccessful: '修改成功，请重新登录'
    }, foundApply: { // 开户申请
        OfficialAuthorizedServiceProvider: '授权服务商',
        TikTok: '风靡全球短视频社交平台，海量新潮年轻用户，通过强导流强曝光的短视频内容带来更高转化率。',
        Google: '全球最大的搜索引擎公司，拥有近30亿月活用户，在客户搜索您的产品或服务的那一刻，恰当其时展示广告。',
        Facebook: '按点击或每千流量付费，运行速度非常快，而且非常易用。另外，广告主还可以通过报表更快的了解不同广告的运行状况。',
        ApplyNow: '立即申请',
        BatchApply: '批量开户',
        ComingSoon: '即将开放',
        Kwai: 'Kwai致力于支持用户分享人生经历，为用户和企业创造价值，我们相信人与人之间的交流和互动会带来商机，与用户搭建联系，让您的品牌受益。',
        TemporarilyClose: '暂停开放',
    }, foundTikTok: { // 开户申请TikTok
        Tip: "营业执照要求:",
        Tip1: "1.请尽量提供清晰且无水印的大陆或香港营业执照证件，且必须是真实最新的版本",
        Tip2: "2.确保营业执照下方的二维码可识别",
        Tip3: "3.提交的营业执照或组织机构代码证照片不清晰或不完整会导致不匹配，核对无误后再提交开户申请",
        Tip1Sea: "1.请尽量提供清晰且无水印的东南亚营业执照证件，且必须是真实最新的版本",
        Port: "端口选择",
        PortTip: "请选择端口",
        PortCnob: "国内CNOB",
        PortChinaEntity: "中国主体",
        PortSea: "东南亚",
        PortAreaMismatch: "公司注册地与所选端口不一致。中国主体请选中国或中国香港，东南亚请选对应国家",
        QualificationType: "资质类型",
        BusinessLicense: '营业执照,无水印版本',
        BusinessLicenseTip: '请上传营业执照附件',
        LicenseTip: '营业执照是指证明您的公司合法性的凭证。请上传PNG、JPG、JPEG 文件',
        CompanyRegistrationLocation: '公司注册地',
        CompanyRegistrationLocationTip: '请选择公司注册地',
        CompanyName: '公司名称',
        CompanyNameTip: '请输入企业名称',
        BusinessLicenseNumber: '社会信用代码',
        BusinessLicenseNumberTip: '请输入社会信用代码',
        AccountTimeZone: '账号时区',
        AccountTimeZoneTip: '请选择账号时区',
        PromotionLink: '产品链接',
        PromotionLinkTip: '请输入推广链接',
        PromotionLinkTip2: '请输入正确链接格式',
        ContactEmail: '联系人邮箱',
        ContactEmailTip: '请输入联系人邮箱',
        ContactEmailTip2: '请输入正确邮箱格式',
        BusinessCenterID: '商务中心ID',
        BusinessCenterIDTip: '请输入商务中心ID',
        Reset: '重置',
        Submit: '提交',
    }, foundTikTokBatch: {
        Intro: '同一份资质提交多条开户申请。系统按队列逐条向 TikTok 建户，单批 50 至 500 条。建户成功后进入 TikTok 审核，审核时间不计入本次提交。',
        PreviewNote: '当前是前台流程预览。提交后只在本页模拟逐条进度，不会在 TikTok 创建账户。能否填写开户清单，由后台白名单决定。',
        PreviewMissing: '未找到这个预览批次，请重新提交。',
        AccessChecking: '正在确认开通状态',
        AccessClosedTitle: '批量开户未开通',
        AccessClosed: '当前账号不在批量开户白名单中。请联系运营在后台「开户审核」里把用户名加入白名单，加入后即可使用，不需要再申请审批。',
        AccessError: '暂时无法确认开通状态，请稍后重试。',
        AccessRetry: '重新检查',
        Qualification: '开户资质',
        Accounts: '账户清单',
        AccountName: '账户名称',
        AccountNameTip: '同一商务中心内不可重名',
        DramaName: '剧目名称',
        DramaTip: '一个账户对应一个剧目，可留空',
        Paste: '粘贴名单',
        PasteTitle: '粘贴账户名单',
        PasteTip: '每行一条。也可写成「账户名称,剧目名称」。',
        PastePlaceholder: '短剧A-001,短剧A\n短剧A-002,短剧A',
        AddRow: '添加一行',
        Clear: '清空清单',
        Generate: '按序号生成',
        Prefix: '名称前缀',
        StartNo: '起始编号',
        GenCount: '生成数量',
        Digits: '编号位数',
        Append: '加入清单',
        Valid: '有效',
        Duplicate: '重名',
        EmptyName: '未填名称',
        OverLimit: '超过 500 条，请拆批提交',
        UnderLimit: '至少填写 1 条账户名称',
        LimitHint: '建议单批 50 至 500 条',
        Submit: '提交批量开户',
        Single: '单条开户',
        Result: '批次进度',
        BatchNo: '批次号',
        Pending: '待处理',
        Processing: '处理中',
        Success: '成功',
        Failed: '失败',
        Unknown: '结果未知',
        All: '全部',
        AdvertiserId: '广告账户 ID',
        FailReason: '失败原因',
        RetryFailed: '只重提失败项',
        RetryUnknown: '回查结果未知',
        Continue: '再开一批',
        ViewRecord: '查看开户记录',
        NoBatchNo: '未返回批次号，请重试',
        Polling: '正在逐条建户，请留在本页查看进度',
        StillRunning: '处理时间较长，可稍后刷新本页查看',
        Refresh: '刷新进度',
        Total: '共',
        Unit: '条',
        Filter: '筛选',
        Remove: '移除',
        ConfirmClear: '清空当前账户清单？',
        NameRequired: '请为每一行填写账户名称，并去掉重名',
        DramaOptional: '剧目',
    }, AccountList: {
        Account: '帐号名称',
        Budget: '预算金额',
        budgetCost: '已消耗金额',
        RequestID: '账户ID',
        RequestIDTip: '请输入账户ID',
        AccountTip: '请输入帐号名称',
        AccountEntity: '开户主体',
        Media: '媒体平台',
        status: '账户状态',
        AccountID: '帐号名称/账户ID',
        Currency: '币种',
        Balance: '账号余额',
        DailyBudget: '每日预算',
        AccountRecharge: '账户充值',
        MinRechargePrice: '最低充值金额',
        DeductionTransfer: '减款转账',
        BindUnbind: '绑定/解绑BC',
        AccountRenaming: '账户更名',
        Fail: '未通过',
        Passed: '已通过',
        InReview: '审核中',
        Operate: '操作',
        Reset: '重置',
        Search: '搜索',
        BatchRecharge: '批量充值',
        BatchAdd: '批量添加',
        BatchOpen: '批量开启',
        ConfirmOpen: '确认开启',
        ConfirmClose: '确认关闭',
        BatchZeroing: '批量清零',
        BatchClose: '批量关闭',
        BatchBinding: '批量绑定/解绑',
        ViewBC: '查看BC',
        NewName: '新名称',
        NewNameTip: '请输入账户新名称',
        Cancel: '取消',
        Confirm: '提交',
        ConfirmModification: '确认修改',
        RechargeAmount: '充值金额',
        RechargeAmountTip: '请输入充值金额',
        BudgetAmount: '预算金额',
        CircuitTime: '巡回时间',
        CircuitTimeTip: '请输入巡回时间',
        BudgetAmountTip: '请输入预算金额',
        DailyBudgetTip: '请输入每日预算',
        ConfirmRecharge: '确认充值',
        ConfirmClear: '确认清空',
        AddAccount: '添加账户',
        BCID: 'BCID',
        EnterBCID: '请输入BC ID',
        SelectBCID: '请选择BC ID',
        Email: '邮箱',
        EnterEmail: '请输入邮箱',
        EnterEmail2: '请输入正确邮箱',
        SelectEmail: '请输入邮箱',
        Permission: '权限',
        SelectPermission: '请选择权限',
        AccountSearch: '请输入帐号名称搜索添加',
        Select: '选择',
        Transfer: '账户减款转账申请',
        AccountBalance: '账户余额',
        EstimatedAeductibleAmount: '预估可减款金额',
        TransferID: '转出账户名称/ID',
        Type: '类型',
        TransferAccount: '转账',
        TransferAmount: '减款',
        TransferMoney: '转出金额',
        Num: '剩余次数',
        EnterTransferAmount: '请输入转出金额',
        IsOut: '是否全部转出',
        Clear: '清零',
        TransferredAccount: '转入账户',
        SelectTransferAccount: '请选择转入账户',
        BindBC: '绑定BC',
        UnbindBC: '解绑BC',
        BindEmail: '绑定邮箱',
        UnbindEmail: '解绑邮箱',
        EnableMonitoring: '开启监控',
        AddMonitoring: '添加监控',
        Edit: '编辑',
        Duration: '开户时长（天）',
        AccountOpeningTime: '开户时间',
        banTime: '封户时间',
    }, AccountRecord: {
        Media: '媒体平台',
        Status: '状态',
        AccountEntity: '开户主体',
        ApplyNumber: '申请ID',
        PromotionLink: '推广链接',
        StartTime: '开始时间',
        EndTime: '结束时间',
        Reset: '重置',
        Search: '搜索',
        Export: '导出',
        AccountApplicationID: '公司名称/申请ID',
        CreatedTime: '申请时间',
        Operate: '操作',
        AccountInfo: '账户信息',
        AccountID: '账户id',
        AccountName: '账户名称',
        CompanyName: '企业名称',
        Currency: '币种',
        AccountBalance: '账户余额',
        View: '查看',
        ViewAccount: '查看账户',
        Edit: '修改',
        Copy: '复制',
        RechargeTips: '温馨提示：未充值的广告账户搭建广告计划容易引起封户，请您先给广告账户充值，谢谢',
    }, AccountRecharge: {
        Add: '添加账户',
        batchAdd: '批量添加账户',
        MediaAccount: '媒体账号',
        AccountPlacement: '投放账号',
        SeriesName: '广告系列名称',
        SeriesNamePrompt: '填写广告系列名称',
        SeriesStatus: '广告系列状态',
        BudgetStatus: '推广系列预算优化',
        GroupName: '广告组名称',
        PlGroupName: '填写广告组名称',
        GroupStatus: '广告组状态',
        DeliveryMethod: '创意投放方式',
        AccountName: '帐号名称',
        MediaPlatform: '媒体平台',
        MonitoringAmount: '监控金额',
        RechargeAmount: '充值金额',
        CircuitTime: '巡回时间',
        State: '状态',
        Modify: '修改',
        Delete: '删除',
        Operate: '操作',
        IsDelete: '是否确认删除',
        SelectMediaPlatform: '请选择媒体平台',
        TransferAccount: '转入账户',
        SelectTransferAccount: '请选择转入账户',
        MonitoringBalance: '监控余额',
        PutMonitoringBalance: '请输入监控账户余额',
        PutRechargeAmount: '请输入充值金额',
        MaximumTwoDecimal: '最大两位小数',
        IntervalTime: '间隔时间',
        PutIntervalTime: '请输入多少小时轮巡',
        Hours: '小时',
        Cancellation: '取消',
        Submit: '提交',
        PleaseEnterInteger: '请输入整数',
        SuccessfullyDeleted: '成功删除',
        accountStatus: '账户状态',
        BudgetBalance: '预算余额',
        AdvertisingAccountBalance: '广告账户余额',
        MonitoringTime: '已监控时长(h)',
        StopDays: '停止天数(天)',
        TourTime: '巡回时间',
        MonitoringStatus: '监控状态',
        Remark: '备注',
    }, AccountDetails: { //开户详情
        DocumentInformation: '单据信息',
        ApplicationID: '申请ID',
        MediaPlatform: '媒体平台',
        CreationTime: '创建时间',
        AccountInformation: '账户信息',
        AccountType: '账户类型',
        Industry: '行业',
        DeliveryCountry: '投放国家',
        AccountTimeZone: '账户时区',
        AccountAuthorization: '账户授权',
        PromotionLink: '推广链接',
        Authorization: '授权',
        Number: '序号',
        EmailID: '授权邮箱/商务中心id',
        Permission: '权限',
        EnterpriseInformation: '企业信息',
        CompanyName: '开户公司名称（中文）',
        LicenseCode: '营业执照社会信用代码',
        License: '营业执照附件',
    }, CheckWallet: {
        WalletRechargeOrder: '钱包充值订单',
        AdvertisingTransactionOrders: '广告交易订单',
        AdvertisingConsumptionDetails: '广告消耗明细',
        WalletRecharge: '钱包充值',
        RechargeAmount: '充值金额',
        EnterRechargeAmount: '请输入充值金额',
        PaymentMethod: '支付方式',
        SelectPaymentMethod: '请选择支付方式',
        Cancellation: '取消',
        ConfirmRecharge: '确认充值',
        AdvertiserIdPlaceholder: "请输入广告账户ID",
        AdvertiserName: "请输入广告名称",
        Reset: "重置",
        Search: "搜索",
        StaticA: "统计数据:总花费：",
        StaticB: ",总广告展现次数：",
        StatTimeDay: "日期",
        AdvertiserId: "广告账号名称/广告账户ID",
        Spend: "总消耗金额",
        Impressions: "广告展现次数",
        Balance: "账户余额",
        advertiserStatus: "账户状态",
    }, Advertisement: { //广告管理
        advertisement: '广告',
        adgroup: '广告组',
        campaign: '广告系列',
        add: '新建广告',
    }, CheckBalance: { // 钱包明细
        OrderNumber: '交易单号',
        ChangeType: '变更类型',
        OperationType: '操作类型',
        Reset: '重置',
        Search: '搜索',
        PreChangeAmount: '变更前金额',
        ChangeAmount: '变更金额',
        createdAt: '创建时间',
        AmountAfterChange: '变更后金额',
        Remarks: '备注',
    }, CheckCredit: { // 钱包明细
        OrderNumber: '交易单号',
        ChangeType: '变更类型',
        OperationType: '操作类型',
        Reset: '重置',
        Search: '搜索',
        PreChangeAmount: '变更前金额',
        createdAt: '创建时间',
        ChangeAmount: '变更金额',
        AmountAfterChange: '变更后金额',
        Remarks: '备注',
        MainContent: '主要内容',
    }, CheckAD: { // 广告交易订单
        AccountType: '媒体平台',
        OrderNumber: '交易单号',
        AdvertisingName: '广告名称',
        OperationType: '操作类型',
        Status: '状态',
        TransferStatus: '转账状态',
        Reset: '重置',
        Search: '搜索',
        PlatformType: '平台类型',
        Account: '金额',
        TransferPlatform: '转账广告账户平台',
        TransferPlatformId: '转账广告账户名称/转账广告账户ID',
        AccountId: '广告账户名称/广告账户ID',
        Remarks: '备注',
        CreatedAt: '交易时间',
    }, CheckPay: { // 钱包充值订单
        Sn: '交易单号',
        Status: '订单状态',
        Reset: '重置',
        Search: '搜索',
        CurrencyName: '币种',
        PayTypeName: '支付方式',
        Amount: '充值金额',
        ExpiresAt: '订单过期时间',
        PayTime: '支付时间',
        Operate: '操作',
        ImmediatePayment: '立即支付',
    }, Settings: {
        Account: "帐号信息",
        Company: "公司信息",
        EmailBind: "邮箱绑定",
        PasswordUpdate: "密码修改",
        Avatar: "头像",
        Nickname: "用户昵称",
        NicknamePlaceholder: "请输入用户昵称",
        NicknameRule: "用户昵称长度只支持(3~20)",
        SubmitForm: '提交',
        Upload: "图片不能超过10M",
        UpdateSuccess: "修改成功",
        EnterpriseName: "企业名称",
        EnterpriseEmail: "企业邮箱",
        EnterprisePhone: "联系人电话",
        EnterpriseAddress: "企业地址",
        EnterpriseNamePlaceholder: "请输入企业名称",
        EnterpriseEmailPlaceholder: "请输入企业邮箱",
        EnterprisePhonePlaceholder: "请输入联系人电话",
        EnterpriseAddressPlaceholder: "请输入企业地址",
        Email: "邮箱",
        OldEmailCode: "邮箱验证码",
        OldEmailCodePlaceholder: "请输入绑定邮箱验证码",
        SendSms: "发送验证码",
        BindEmail: "绑定邮箱",
        BindEmailPlaceholder: "请输入绑定邮箱",
        BindEmailCode: "邮箱验证码",
        BindEmailCodePlaceholder: "请输入邮箱验证码",
        SendCodeSuccess: "成功发送验证码",
        EmailBindSuccess: "邮箱绑定成功",
        EmailBindCodePlaceholder: "请输入邮箱验证码",
        EmailSuccess: "请输入正确邮箱",
        OldPassword: "老密码",
        OldPasswordPlaceholder: "请输入老密码",
        Password: "新密码",
        PasswordPlaceholder: "请输入新密码",
        RePassword: "确认密码",
        RePasswordPlaceholder: "请输入确认密码",
        PasswordUpdateSuccess: "密码修改成功",
        UserAccount: "用户账号",
        ChangePhoneNumber: "更换手机号",
    }, Help: {
        ReleaseTime: "发布时间",
        Title: "标题",
    }, Other: {
        TikTokPlatform: "TikTok平台-开户申请",
        NewQualification: "新建资质",
        VerifiedQualifications: "已验证资质",
        SelectVerifiedQualification: "选择已验证的资质证明以便再次使用",
        AutomaticallyReview: "使用已验证的资质证明创建的广告账户将自动通过审核",
        SelectVerifiedQualifications: "请选择已验证资质",
        AdvertisingAccounts: "个广告账户",
        AdvertisingArea: "广告投放地区",
        PleaseSelectAdvertising: "请选择广告投放地区",
        NumberApp: "申请数量",
        PleaseNumberApp: "请输入申请数量",
        LegalPerson: "法人姓名",
        PleaseLegalPerson: "请输入法人姓名",
        IDNumber: "法人身份证",
        PleaseIDNumber: "请输入法人身份证",
        BankAccountNumber: "法人银行账号",
        PleaseBankAccountNumber: "请输入法人银行账号",
        BankMobileNumber: "法人手机",
        PleaseBankMobileNumber: "请输入法人手机",
        AccountSelection: "账号选择",
        FormEntry: "表格录入",
        BulkAdvertisingAccounts: "可从excel里直接复制广告账户ID，依次空格分隔，示例如下",
        BatchSearch: "批量搜索",
        ConfirmSub: "确认提交",
        AddRunningAccount: "添加运行账户",
        MonitorStatus: "监控状态",
        Balance: "余额",
        ConfirmStop: "确认停止",
        RunAccountList: "运行账户列表",
        SearchRunAccount: "搜索运行账户",
        BatchClose: "批量关闭操作",
        RemainingTimes: "今天剩余转账次数",
        UKTimeZone: "注:清留意单个账户当天只能互转20次，操作时间以英国时区为准~",
        PleaseEnterBalance: "请输入余额",
        PleaseBudgetBalance: '请输入预算余额',
        EditorialMonitor: '编辑监控',
        AdvertiseAccountID: '广告账户ID',
        ConfirmAdd: '确认添加',
        SearchAddAccount: '搜索添加账户',
        AddEnableAccounts: '批量添加开启账户',
        OpenAccountList: '开启账户列表',
        BatchOperations: '批量操作',
        Phone: '手机号码',
        ReleaseArea: '投放地区',
        WeChatBind: '微信绑定',
        Bind: '绑定',
        UnBind: '解绑',
        SubCustomerAlias: '子客户别名',
        SubCustomers: '子客户',
        PleaseSubCustomerAlias: '请输入子客户别名',
        AccountBalance: '账户金额',
        KwaiPlatform: "Kwai平台-开户申请",
        BusinessScope: "营业范围",
        BusinessLicense: "营业范围. 请与营业执照保持一致",
        AdType: "广告账户类型",
        EffectAdAccount: "效果广告账户",
        Industry: "投放内容所属行业",
        SeleteIndustry: "请选择投放内容所属行业",
        ProductBrandName: "产品或品牌名称",
        PleaseProductBrandName: "请输入产品或品牌名称",
        PleaseRregisAddress: "请输入公司注册地址",
        RregisAddress: "公司注册地址",
        CheckEmail: "查看邮箱",
        BindEmail: "绑定邮箱",
        UnbindEmail: "解绑邮箱",
        BindUnbindEmail: "绑定/解绑邮箱",
        SerialNumber: "编号",
        BindStatus: "绑定状态",
        GooglePlatform: "Google平台-开户申请",
    }, Omissions: {
        OnlineRecharge: '线上充值',
        ActualAmount: '实付金额',
        SelectRechargeMethod: '选择充值方式',
        OnlinePay: '在线支付',
        OfflineTransfer: '线下转账',
        Recommend: '推荐',
        OnlinePayMethods: '人民币充值选择在线支付方式，支持使用',
        USDPayoptions: '美元充值选择线下转账，支持使用',
        RemainingBalance: '剩余余额',
        Increase: '增加',
        Decrease: '减少',
        ExchangeRate: '手续汇率',
        HandlingFees: '手续费',
        TransactionDetails: '交易详情',
        TransactionID: '交易ID',
        TransactionVoucher: '交易凭证',
        Remark: '备注',
        DeductedBalance: '实扣余额',
        MonitoringOn: '监控开启',
        MonitoringOff: '监控关闭',
        MasterAccount: '主账户',
        SubAccount: '成员账号',
        Username: '用户名',
        AdvertiserNum: '广告账户数量',
        CreditBalance: '授信余额',
        LastLoginTime: '最后登录时间',
        BalanceAllocation: '余额分配',
        AccountAllocation: '账户分配',
        ResetPassword: '重置密码',
        UserDetail: '账户详情',
        NewAccount: '新建账号',
        LogRecording: '日志记录',
        AddSubUser: '添加成员',
        PleaseName: '请输入名称（不超过五个字段的名称）',
        LoginPassword: '请输入6-20位登录密码（需含大小写字母）',
        ConfigPleasePassword: '请再次输入密码',
        username: '用户名',
        pleasePassword: '确认密码',
        AdjustmentType: '调账类型',
        Confirm: '确认',
        AssignedAdvertAccounts: '已分配广告账户',
        AddSubUserDetail: '成员账户详情',
        AllocatedAmount: '已分配金额',
        AdvertiserName: '账号名称',
        AdvertiserID: '账号ID',
        ConsumedBalance: '已消耗余额',
        SystemInfo: '系统信息',
        CurrentWalletBalance: '当前钱包余额',
        CurrentCreditBalance: '当前信用余额',
        AdjustmentAmount: '调账金额',
        PleaseAdjustmentAmount: '请输入调账金额',
        PleaseSelectType: '请选择类型',
        MasterAccountBalance: '主账户余额',
        MasterAccountCreditBalance: '主账户信用余额',
        AccountRecycle: '账户回收',
        AccountRecycleList: '账户回收列表',
    },
    SubClient: {
        OnlineRecharge: '线上充值',
        ProxyLinks: '代理链接',
        SubManagement: '客户管理',
        RiskControlStatus: '风控状态',
        Normal: '正常',
        Disable: '禁用',
        Username: '用户名称',
        Mail: '邮箱',
        WalletBalance: '钱包余额',
        AccountBalance: '信用余额',
        AdvertiserNumber: '广告账户数量',
        Phone: '手机号',
        BalanceRecharge: '余额充值',
        BalanceReduction: '余额减款',
        BasicInformation: '基本信息',
        UserUpdate: '用户更名',
        LinkAccounts: '关联账户',
        TransactionRecords: '交易记录',
        OpenRecords: '开户记录',
        UserId: '用户ID',
        ReductionChannels: '减款渠道',
        MyBalance: '我的余额',
        SubClientBalance: '子客户余额',
        AmountReduction: '减款金额',
        PleaseAmountReduction: '请输入减款金额',
        BalanceAfterDeduction: '减款后余额',
        Remark: '备注',
        PleaseRemark: '请输入备注',
        Recharge: '充值',
        RechargeChannels: '充值渠道',
        RechargeAmount: '充值金额',
        PleaseRechargeAmount: '请输入充值金额',
        BalanceAfterRecharge: '充值后余额',
        EditName: '编辑名称',
        ChangeName: '变更名称',
        SubClientname: '子客户名称',
        AdvertiserNum: '广告数量',
        LoginRest: '登录限制',
        OpenRest: '开户限制',
        AccountClosureRate: '账号封户率',
        LastLoginIP: '最后登录IP',
        LastLoginTime: '最近登录时间',
        TransactionType: '交易类型',
        Reduction: '减款',
        Operator: '操作人',
        TransactionAmount: '交易金额',
        CreditBalanceRecord: '信用余额明细',
    },
    Notice: {
        BatchRead: '批量已读',
        MessageStatus: '消息状态',
        Title: '标题',
        Summary: '摘要',
        ReleaseTime: '发布时间',
        MessageType: '消息类型',
        Operate: '操作',
        QueryDetails: '查询详情',
        Details: '详情',
        PleaseEnterMessageTitle: '请输入消息标题',
        All: '全部',
        Read: '已读',
        Unread: '未读',
        SystemNotice: '系统通知',
        OrdinaryNotice: '普通通知',
    },
    Zero:{
        ConfirmBatchZero: '确认批量清零',
        Reminder: '清零提醒',
        Prompt1: '1、最终转出金额以平台实际金额为准',
        Prompt2: '2、最终清零金额以平台实际金额为准，实际清零的金额可在账单管理的金额变动记录查看处理进度，处理时间需要1-3个工作日',
        Prompt3: '3、当前清零仅支持封户的广告账户',
    },
    Partner:{
        marketingToolintro: '专注TIKTOK生态效率工具开发，更懂TIKTOK达人带货生态',
        crossBorderBrowserintro: '站斧浏览器专为每个账号提供安全独立运营环境',
        storeOperationToolsintro: '专注TIKTOK生态效率工具开发，更懂TIKTOK达人带货生态',
        USCloudPhoneintro: 'Ushop店铺智能管理ERP',
        TermsService: '工具推荐系列为东坤科技Adseasy的合作方提供服务，非本平台服务，请确认对应平台的服务内容以及协议后使用',
        serviceRecommendation: '服务推荐',
        marketingToolDetail: '稳定批量邀约/私信达人，每天触达上万达人；免费提供千万+精准带货达人库、内置AI生成话术，支持多语言AI辅助回复达人；支持邮件群发等多种站内外方式触达；洞悉竞品、同行店铺的带货达人，达秘一键触达、附带达人管理系统，邀约管理流程SOP化。',
        crossBorderBrowserDetail: '立即注册，新用户享无门槛券体验；安全高效运营店铺；站斧浏览器专为每个账号提供安全独立运营环境。',
        storeOperationToolsDetail: '致力于打造AI自动化电商管理运营系统工具，支持TikTok、Lazada、Shopee、Shein等多家电商平台本土及跨境店铺。',
        USCloudPhoneDetail: '毫秒级响应·从未如此流畅；支持平台:拼多多、抖店、淘宝网、Shopee、Paypal、Tiktok等众多平台 ；云号管理井然有序 ；信息传输快人一步。',
    },
    MonthSettlement: {
        list: '月结账单',
        enterpriseName: '公司名称',
        monthBill: '账单月份',
        money: '本期账单金额',
        file: '下载',
        createdAt: '生成时间',
        remark: '备注',

    }
}